export default __webpack_public_path__ + "static/media/mobile-contact-us-banner.3d888461.png";